<script>
  import { onMount } from 'svelte';
  import { createScene } from "./perlinProd";
  let el;
  
  onMount(() => {
    createScene(el)
  });

</script>

<canvas bind:this={el}></canvas>
